import React from 'react';
import { availableVariables } from '../template-editor/constants';

const VariablesPanel = ({ fieldId, insertVariable, insertVariableNewLine }) => (
  <div style={{
    marginTop: '5px',
    padding: '6px',
    border: '1px solid var(--border)',
    borderRadius: '3px',
    backgroundColor: 'var(--bg)',
    maxHeight: '150px',
    overflowY: 'auto',
  }}>
    <div style={{ fontSize: '10px', fontWeight: 'bold', marginBottom: '4px' }}>
      Dost&#x119;pne zmienne:
    </div>
    <div style={{ display: 'flex', flexDirection: 'column', gap: '3px' }}>
      {availableVariables.map((variable, index) => (
        <div key={index} style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
          <div style={{ fontSize: '8px', fontWeight: 'bold', color: 'var(--text-secondary)' }}>{variable.name}</div>
          <div style={{ display: 'flex', gap: '2px' }}>
            <button
              type="button"
              onClick={() => insertVariable(fieldId, variable.name)}
              style={{
                backgroundColor: 'var(--border)', border: '1px solid var(--border)',
                padding: '4px 10px', cursor: 'pointer', fontSize: '11px', flex: 1,
              }}
              title={`Wstaw ${variable.name} obok tekstu`}
            >
              + Obok
            </button>
            <button
              type="button"
              onClick={() => insertVariableNewLine(fieldId, variable.name)}
              style={{
                backgroundColor: 'var(--success-light)', border: '1px solid var(--success-light)',
                padding: '4px 10px', cursor: 'pointer', fontSize: '11px', flex: 1,
              }}
              title={`Wstaw ${variable.name} w nowej linii`}
            >
              + Nowa linia
            </button>
          </div>
        </div>
      ))}
    </div>
  </div>
);

export default VariablesPanel;
